import { Component, OnInit } from '@angular/core';
import {NgbModal, ModalDismissReasons, NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { BackupsModel, Backup} from './../../models/backups.model';


@Component({
  selector: 'app-modal-backup',
  templateUrl: './modal-backup.component.html',
  styles: []
})
export class ModalBackupComponent implements OnInit {

  formControl = new FormControl('');
  modalForm : FormGroup;
  backup: Backup;
  private _backupModel = new BackupsModel ;
  server: string;

  constructor(public activeModal: NgbActiveModal, private fb: FormBuilder) { }

  ngOnInit() {
    this.modalForm = this.fb.group({
      clave: [this.backup ? this.backup.clave : null],
      server_name: [this.backup ? this.backup.servidorNombre : null],
      web: [this.backup ? this.backup.web : null],
      ruta: [this.backup ? this.backup.ruta : null],
      discoDuro: [this.backup ? this.backup.discoDuro : null],
      responsable: [this.backup ? this.backup.responsable : null],
      tipo: [this.backup ? this.backup.tipo : null],
      fechaEntregable: [this.backup ? this.backup.fechaEntregable : null],
    });
  }

  adminBackup(){
    this.activeModal.close('Guardado Datos');
    this._backupModel.createBackup(this.modalForm.value, this.server);
  }

}
